import { render } from "./FramePrcRender.vue?vue&type=template&id=24ff4536&scoped=true"
import script from "./FramePrcRender.vue?vue&type=script&lang=js"
export * from "./FramePrcRender.vue?vue&type=script&lang=js"

import "./FramePrcRender.vue?vue&type=style&index=0&id=24ff4536&lang=less"
import "./FramePrcRender.vue?vue&type=style&index=1&id=24ff4536&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ff4536"]])

export default __exports__